import { Space, Typography } from "antd";
import React, { Component } from "react";

class ContactData extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "start",
          width: this.props.userData.isMobile ? "100%" : "80%",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography.Title
            level={5}
            style={{
              margin: "10px 0px",
            }}
          >
            Atención al cliente
          </Typography.Title>
        </div>
        <Space
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
            alignItems: "flex-start",
          }}
        >
          <Typography>
            El CLIENTE podrá ponerse en contacto con el Servicio de atención al
            Cliente por medio de los siguientes métodos de contacto:
          </Typography>
          <Typography>Nuestra página WEB: nadunet.es</Typography>
          <Typography>
            Nuestro correo de atención al cliente: contacto@nadunet.es
          </Typography>
          <Typography>
            Nuestro número de atención comercial: 960200600
          </Typography>
          <Typography>
            También podrá revisar sus datos, SERVICIOS contratados, consumos y
            tráfico a través del área de cliente: mi.nadunet.es
          </Typography>
          <Typography>{`Agente comercial: ${this.props.userData.author.name} (${this.props.userData.author.mail}).`}</Typography>
        </Space>
      </div>
    );
  }
}

export default ContactData;



// WEBPACK FOOTER //
// ./src/views/Contract/components/ContactData.jsx